import { render, staticRenderFns } from "./same.vue?vue&type=template&id=6ae97173&scoped=true"
import script from "./same.vue?vue&type=script&lang=js"
export * from "./same.vue?vue&type=script&lang=js"
import style0 from "./same.vue?vue&type=style&index=0&id=6ae97173&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae97173",
  null
  
)

export default component.exports